module.exports = __webpack_public_path__ + "media/great-job.9a58d24b.mp3";